import { getCookie, getLang } from "./utils";

const RCTOKEN = import.meta.env.REACT_APP_RCTOKEN || '';
const API = import.meta.env.REACT_APP_API_URL || '';

function parseJSON(response) {
  return response.text().then((text) => {
    try {
      return text ? JSON.parse(text) : {};
    } catch (e) {
      return false;
    }
  });
}

function defaultDeAuth() {
  window.document.cookie = 'token= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';
  window.document.cookie = 'email= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';
}

export function flipRules(inputs) {
  const result = inputs.map((field) => {
    const rulesList = field.rules;
    const newRulesList = [];
    const newMessagesList = [];
    rulesList.forEach((rule) => {
      Object.getOwnPropertyNames(rule).forEach((ruleRow) => {
        const property = rule[ruleRow];
        if (ruleRow === 'type') {
          newRulesList.push(`is${property[0].toUpperCase()}${property.substr(1)}`);
          newMessagesList.push(rule.message);
        }
        if (ruleRow === 'required') {
          newRulesList.push('required');
          newMessagesList.push(rule.message);
        }
        if (ruleRow === 'min') {
          newRulesList.push(`minStringLength:${property}`);
          newMessagesList.push(rule.message);
        }
        if (ruleRow === 'max') {
          newRulesList.push(`maxStringLength:${property}`);
          newMessagesList.push(rule.message);
        }
        if (ruleRow === 'pattern') {
          newRulesList.push(['matchRegexp:', property].join(''));
          newMessagesList.push(rule.message);
        }
      });
    });
    const resField = Object.assign({}, field);
    resField.rules = newRulesList;
    resField.messages = newMessagesList;
    return resField;
  });
  return result;
}

/** set language */
const lang = getLang();
localStorage.lang = lang;


const fetchPerform = async (reqUrl, body, method, recaptcha, authToken) => {
  const headers = authToken ? {
    Authorization: `Bearer ${authToken}`,
  } : {};
  try {
    const response = await fetch(reqUrl, {
      mode: 'cors',
      method,
      credentials: 'include',
      body: method === "POST" ? getFormData({ ...body, recaptcha }) : undefined,
      headers
    });

    const parsed = await parseJSON(response);

    if (response.status === 404) {
      return {
        data: {
          message: "Страница не найдена или у вас нет доступа"
        }, status: 404, success: false
      }
    }
    if (response.status === 500) {
      return {
        data: {
          message: "Ошибка сервера"
        }, status: 500, success: false
      }
    }

    if (response.status < 200 || response.status >= 300) {
      window.showMessage("Потеряно соединение с сервером");
      return { data: {}, status: 200, success: false };
    }

    if (parsed.status === 401) {
      window.showMessage(parsed.data[0].message);
      window.deAuth();
      defaultDeAuth();
    }

    return parsed;
  } catch (error) {
    window.showMessage("Ошибка запроса к серверу");
    return { data: {}, status: 200, success: false };
  }
}

const preflight = (url, method = "GET", body = {}, apiVersion = "v1") => {
  Object.keys(body).forEach(key => body[key] === undefined && delete body[key])
  const lang = localStorage.lang?.toLowerCase() || "ru";
  const authToken = body.hasOwnProperty("authToken") ? getCookie("token") : null;
  const reqUrl = `${API}/api/${apiVersion}/${lang}${url}`
  delete body.authToken;
  if (body && body.recaptcha) {
    try {
      return window.grecaptcha.execute(RCTOKEN, { action: body.recaptcha }).then(
        (recaptcha) => fetchPerform(reqUrl, body, method, recaptcha, authToken)
      );
    } catch (error) {
      window.showMessage("Не удалось запустить проверку ReCaptcha");
    }

  } else {
    return fetchPerform(reqUrl, body, method, null, authToken)
  }
};

const getFormData = (body) => {
  const formData = new FormData();
  Object.entries(body)
    .forEach(([key, value]) => {
      if (value != null) {
        (Array.isArray(value) ? value : [value])
          .forEach(item => formData.append(key, item));
      }
    });
  return formData;
};


export default {
  calc: (url, amount, reverse, hash) => preflight(`/exchange/calc/${url}?amount=${amount}&isReverse=${reverse ? 'Y' : 0}${hash ? `&hash=${hash}` : ''}`),
  getCalcRate: (url, hash) => preflight(`/exchange/rate/${url}${hash ? `?hash=${hash}` : ''}`),
  getCalcAmount: (url, amount) => preflight(`/exchange/rate/${url}${amount ? `?amount=${amount}` : ''}`),
  getPopularDirections: (url, hash) => preflight(`/exchange/popular`),
  sendPhoneVerify: (id, code) => preflight(`/exchange/verification-phone/${id}`, "POST", { code }),
  getNewPhoneVerify: id => preflight(`/exchange/verification-recall/${id}`, "POST"),
  auth: (email, password) => preflight(`/auth/login`, "POST", { email, password, recaptcha: "auth" }),
  getSocAuthLinks: () => preflight(`/soc-auth/links`),
  getSocAuthLogin: (getString) => preflight(`/soc-auth/auth` + getString + "", "GET"),
  register: (email, password, extra) => preflight(`/auth/signup`, "POST", { email, password, refCode: extra.refCode, link: extra.link, recaptcha: "register" }),
  activate: token => preflight(`/auth/activate`, "POST", { token }),
  resetPassword: email => preflight(`/auth/request-password-reset`, "POST", { email, recaptcha: "resetPassword" }),
  setNewPassword: (token, password) => preflight(`/auth/reset-password`, "POST", { token, password }),
  createOrder: (url, fields) => preflight(`/exchange/process/${url}`, "POST", { ...fields, recaptcha: "createOrder", authToken: true }),
  setPaid: id => preflight(`/exchange/set-paid/${id}`, "POST"),
  setDepositPaid: hash => preflight(`/order/deposit/set-paid/transaction/${hash}`, "POST", { authToken: true, }, "v2"),
  acceptRateUpdate: (hash, code) => preflight(`/exchange/confirm-change-rate/${code}`, "POST", { hash }),
  getNewRate: (code) => preflight(`/exchange/new-rate/${code}`, "GET"),
  acceptNewRate: (code) => preflight(`/exchange/confirm-rate-change/${code}`, "GET"),
  refuseNewRate: (code) => preflight(`/exchange/refuse-rate-change/${code}`, "GET"),
  repeatInfo: (code) => preflight(`/exchange/repeat-info/${code}`, "GET", { authToken: true }),
  uploadReceipt: (hash, file) => preflight(`/order/deposit/receipt/upload/${hash}`, "POST", { receipt: file, authToken: true }, "v2"),
  getReceiptStatus: hash => preflight(`/order/deposit/receipt/status?receiptId=${hash}`, "GET", { authToken: true }, "v2"),

  cancelOrder: code => preflight(`/exchange/cancel/${code}`, "POST"),
  // KYC
  createKYCSession: (orderHash) => preflight(`/kyc/verification/create-session`, "POST", { orderHash, authToken: true }, "v2"),
  getKYCStatus: (id) => preflight(`/kyc/verification/status/${id}`, "GET"),

  sendFeedback: (code, text, authToken) => preflight(`/exchange/comment/${code}`, "POST", { authToken, text }),
  repeatOrder: (code, amount, hash) => preflight(`/exchange/repeat/${code}`, "POST", { amount, hash, authToken: true, recaptcha: "repeatOrder" }),
  getOrderState: (id, authToken) => preflight(`/exchange/status/${id}`, "GET", { authToken }),
  getOrdersFilter: authToken => preflight(`/user/order-list-params`, "GET", { authToken }),
  getOrdersList: (authToken, params = {}) => preflight(`/user/order-list?per-page=${params.perPage || 10}&page=${params.page || 1}${params.paymentStatus ? (`&paymentStatus=${params.paymentStatus}`) : ''}${params.sort ? (`&sort=${params.sort}`) : ''}`, "GET", { authToken }),
  getRefIncomeList: (authToken, params = {}) => preflight(`/referal/accruals-history?per-page=${params.perPage}&page=${params.page}${params.paymentStatus ? (`&paymentStatus=${params.paymentStatus}`) : ''}`, "GET", { authToken }),
  getRefStatusPage: (authToken, id) => preflight(`/referal/withdrawal-item/${id}`, "GET", { authToken }),
  getRefOutcomeList: (authToken, params = {}) => preflight(`/referal/withdrawal-history?per-page=${params.perPage}&page=${params.page}${params.paymentStatus ? (`&paymentStatus=${params.paymentStatus}`) : ''}`, "GET", { authToken }),
  getFromSystems: () => preflight(`/exchange/from-payment-systems?noInputs=1`),
  getDefaultSystems: () => preflight(`/exchange/default`),
  getSystemsWithProp: (fromSystem, fromCurrencyId, flip = true) => preflight(`/exchange/group?ownDirection=1&fromPaymentSystemId=${fromSystem}${fromCurrencyId ? (`&fromCurrencyId=${fromCurrencyId}`) : ''}`)
    .then((data) => {
      if (!data) {
        return false;
      }
      if (data.data.length === 0) {
        return false;
      }
      if (fromCurrencyId) {
        /** SBP-OFF HARDCODE */

        const BANK_SKIP = [] // "Sberbank", "Tinkoff"
        console.warn("SBP-OFF HARDCODE", BANK_SKIP)
        const selectedCurrency = data.data[0].currencies.find(item => Number(item.id) === Number(fromCurrencyId));
        selectedCurrency.directions.forEach(system => {
          if (system.type !== 0) { // type = 0 - bank
            return false
          }
          if (BANK_SKIP.includes(system.className)) {
            return false
          }
          system.currencies.forEach(currency => {
            const inputs = currency.inputs;
            const alternateNumberIndex = inputs.findIndex(({ id }) => id === "alternateNumber");

            if (alternateNumberIndex !== -1) {
              const useAlternateNumberIndex = inputs.findIndex(({ id }) => id === "useAlternateNumber");
              const numberIndex = inputs.findIndex(({ id }) => id === "number");

              inputs[useAlternateNumberIndex] = {
                ...inputs[useAlternateNumberIndex],
                type: 'hidden',
                value: "1",
              }
              inputs[alternateNumberIndex] = {
                ...inputs[alternateNumberIndex],
                condition: undefined,
              }
              inputs[numberIndex] = {
                ...inputs[numberIndex],
                type: 'hidden',
              }

            }
          })
        })
        /** */
        return data.data[0].currencies.find(item => Number(item.id) === Number(fromCurrencyId));
      } else {
        return data.data[0].currencies[0];
      }
    }),
  getVerifySystemsList: (authToken) => preflight(`/user/verification-form-params`, "GET", { authToken }),
  getVerifyFields: (authToken, fromSystem, fromCurrencyId) => preflight(`/user/verification-form?paymentSystemId=${fromSystem}${fromCurrencyId ? (`&currencyId=${fromCurrencyId}`) : ''}`, "GET", { authToken }).then((data) => {
    if (!data.data.inputs) return false;
    const inputs = flipRules(data.data.inputs);
    return inputs;
  }),
  sendVerifyCard: (authToken, system, currency, fields) => preflight(`/user/verification-form`, "POST", { ...fields, authToken, paymentSystemId: system, currencyId: currency }),

  getRefSystemsList: (authToken) => preflight(`/referal/index`, "GET", { authToken }),
  getReferalsList: (authToken, params = {}) => preflight(`/referal/list?page=${params.page || 1}&per-page=${params.perPage || 10}`, "GET", { authToken }),
  getRefWithdrawForm: (authToken, system, currency) => preflight(`/referal/withdrawal-form`, "POST", { authToken, paymentSystemId: system, currencyId: currency })
    .then((data) => {
      const fields = data.data;
      fields.inputs = fields.inputs && flipRules(fields.inputs);
      return fields;
    }),
  clearOrdersHistory: (authToken) => preflight(`/user/order-delete-all`, "POST", { authToken }),
  clearReqs: (authToken) => preflight(`/user/req-delete-all`, "POST", { authToken }),
  deleteAccount: (authToken) => preflight(`/user/delete`, "POST", { authToken }),
  getWalletFields: (authToken, fromSystem, fromCurrencyId) => preflight(`/user/req-form?paymentSystemId=${fromSystem}${fromCurrencyId ? (`&currencyId=${fromCurrencyId}`) : ''}`, "POST", { authToken })
    .then((data) => {
      if (!data.data.inputs) return false;
      const inputs = flipRules(data.data.inputs);
      return inputs;
    }),
  sendWallet: (authToken, system, currency, fields) => preflight(`/user/req-form`, "POST", { ...fields, paymentSystemId: system, currencyId: currency, authToken }),
  getWalletList: (authToken, system, currency, page, type) => preflight(`
  /user/req-list?per-page=100&page=${page || 0}${type ? type : ''}${system ? `&paymentSystemId=${system}` : ''}${currency ? `&currencyId=${currency}` : ''}
  `, "GET", { authToken }),
  getVerifyedList: (authToken) => preflight(`/user/verification`, "GET", { authToken }),
  getWalletSystems: (authToken) => preflight(`/user/req-form-params`, "GET", { authToken }),
  getProfileData: (authToken) => preflight(`/user/profile`, "GET", { authToken }),
  setProfileLang: (authToken) => preflight(`/user/set-profile-language`, "GET", { authToken }),
  logout: (authToken) => preflight(`/auth/logout`, "GET", { authToken }),
  sendWithdrawReq: (authToken, system, currency, fields) => preflight(`/referal/withdrawal`, "POST", { ...fields, paymentSystemId: system, currencyId: currency, authToken }),
  deleteWallet: (authToken, id) => preflight(`/user/req-delete/${id}`, "GET", { authToken }),
  changePassword: (authToken, password, newPassword) => preflight(`/user/reset-password`, "POST", { authToken, old: password, new: newPassword }),
  getSiteStatus: url => preflight(`/exchange/config${url ? `?exchangeUrl=${url}` : ''}`),
  // DEPRECATED getNewsList: (page = 1, perPage = 8) => preflight(`/news/index?page=${page}&per-page=${perPage}/`),
  // DEPRECATED getNewsPage: (id = 0) => preflight(`/news/view/${id}`),
  getHelpList: (page = 1, perPage = 30) => preflight(`/article/help?per-page=${perPage}`),
  // DEPRECATED getHelpSection: (id, page = 1, perPage = 30) => preflight(`/page/get-help-questions/${id}?page=${page}&per-page=${perPage}/`),
  // DEPRECATED getHelpPage: id => preflight(`/page/view-help-question/${id}`),
  getViewPage: (url, count = 30, page = 1) => preflight(`/article/${url}?per-page=${count}&page=${page}`),
  sendPhotoVerify: (order, photo) => preflight(`/exchange/verification/${order}`, "POST", { photo }),
  sendPhotoVerifyMulti: (order, photos) => preflight(`/exchange/verification/${order}`, "POST", { 'photo[]': photos }),
  getPaymentForm: hash => preflight(`/exchange/payment/${hash}`)
    .then((data) => {
      if (data.data) {
        const system = data.data;
        system.inputs = flipRules(system.inputs);
        return system;
      }
      return false;
    }),
  sendPayment: (payment, fields) => preflight(`/exchange/payment/${payment}`, "POST", { ...fields }),
  getReserveList: () => preflight(`/exchange/reserve`),
  getDynPage: page => preflight(`${API}/api/page/view/${page}`),
  getDictionary: () => preflight(`/exchange/dictionary`)
    .then((out) => {
      if (out.success === true) {
        localStorage.setItem("dictionary", JSON.stringify(out.data));
        return out
      }
    })
};